// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__z4wC9","modalBody":"MealsPop_modalBody__79h5L"};